export default "__VITE_ASSET__CfFDYIeh__"